import React from 'react';
import './CustomProgressBar.css';

/**
 * Custom ProgressBar component matching Polaris design system
 * Replaces deprecated @shopify/polaris ProgressBar
 * 
 * @param {number} progress - Progress value from 0 to 100
 * @param {string} size - Size of the progress bar: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} tone - Color tone: 'primary', 'success', 'critical', 'warning' (default: 'primary')
 */
export default function CustomProgressBar({ progress = 0, size = 'medium', tone = 'primary' }) {
    // Ensure progress is between 0 and 100
    const normalizedProgress = Math.min(Math.max(progress, 0), 100);
    
    return (
        <div 
            className={`custom-progress-bar custom-progress-bar--${size}`}
            role="progressbar"
            aria-valuenow={normalizedProgress}
            aria-valuemin="0"
            aria-valuemax="100"
        >
            <div className="custom-progress-bar__track">
                <div 
                    className={`custom-progress-bar__fill custom-progress-bar__fill--${tone}`}
                    style={{ width: `${normalizedProgress}%` }}
                />
            </div>
        </div>
    );
}
